import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import CtasPagarRecPrintModal from '../relatorios/CtasPagarRecPrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import RelContasPagRec from '../tutoriais/RelContasPagRec';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    formLiqVisivel: false,

    vlrPagar: 0,
    vlrPag: 0,
    vlrReceber: 0,
    vlrRec: 0,
    vlrProvisao: 0,
    vlrTotal: 0,

    registroParc: [],

    filtros: {
      tipoTela: 'CPR',
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0)).format('DD/MM/YYYY'),
      // buscaDataIni: moment().format('DD/MM/YYYY'),
      // buscaDataFim: moment().format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'A', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      },
        this.getListaRegistros
      )
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao } = this.state.filtros;


    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }


    axios
      .get('/titulos/listaFichaFinanc', {
        params: {
          page: pagina,
          limite: limite,
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          tipo: buscaTipo.key,
          situacao: buscaSituacao.key,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          tipoDoc: buscaTipoDoc.key,
          ctaCorrente: buscaCtaCorrente.key,
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        },
          this.getSaldos()
        );

      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };

  getSaldos = () => {
    this.setState({ vlrPagar: 0, vlrPag: 0, vlrReceber: 0, vlrRec: 0, vlrProvisao: 0, vlrTotal: 0 });

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/titulos/somatorioFichaFinanc', {
        params: {
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          tipo: buscaTipo.key,
          situacao: buscaSituacao.key,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          tipoDoc: buscaTipoDoc.key,
          ctaCorrente: buscaCtaCorrente.key,
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        this.setState({
          vlrPago: response.data.vlrPag,
          vlrRecebido: response.data.vlrRec,
          vlrSaldo: parseFloat(response.data.vlrRec) - parseFloat(response.data.vlrPag),
          vlrReceber: response.data.vlrReceber,
          vlrPagar: response.data.vlrPagar,
          vlrProvisao: parseFloat(response.data.vlrReceber) - parseFloat(response.data.vlrPagar),
        });
      })
      .catch(erro => {
        console.warn(erro);
      });
  };








  onLiquidarClick = () => {
    this.setState({
      formLiqVisivel: false,
    },
      this.getListaRegistros
    )
  };

  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tit_idf,
          parc: registro.tparc_parcela,
        }
      })
      .then(response => {
        const { data } = response;

        data.tparc_tipo_doc = {
          key: String(this.state.usuario.par_doc_padrao),
          label: this.state.usuario.td_descricao,
        }
        data.tparc_conta_corrente = {
          key: String(this.state.usuario.par_cta_corrente_padrao),
          label: this.state.usuario.cc_descricao,
        }

        data.pgto_data = moment().format('DD/MM/YYYY');
        data.tipoTela = 'LIQ';

        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value,
      pagina: 1
    },
      this.getListaRegistros
    );
  };

  onChangePessoa = event => {
    const { filtros } = this.state;
    filtros['buscaPessoa'] = event.buscaPessoa;
    this.setState(
      event,
      this.getListaRegistros
    );
  }





  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (registro) => {
    return (
      <div>
        {getTemPermissao('CtasPagarRecPage', 'editar') ? (
          <Tooltip title={registro.situacao_parcela === 'PAGO' ? 'Abrir Parcela' : 'Liquidar Parcela'}>
            <Button type="primary" size="small" onClick={() => this.onVisualizarClick(registro)} icon="check" placement="topLeft" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
          </Tooltip>
        ) : null}
      </div>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderParcela = (tparc_parcela, registro) => {
    return (
      <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
    );
  };

  renderCtaFin = (pc_abreviatura, registro) => {
    return (
      <Tooltip title={registro.pc_descricao}>{pc_abreviatura}</Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros
    )
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, registroParc, formFiltroVisivel, formLiqVisivel,
      filtros, total, pagina, limite } = this.state;
    const { buscaPessoa } = this.state.filtros;

    // console.log('CtasPagarRecPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Contas à Pagar/Receber</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 50 }}>
            <Col xs={24} >

              <Row>
                <Col xs={24} sm={22} style={{ marginTop: -4 }} className="camposEspacoDireita">

                  <Col xs={2} style={{ width: 110, marginLeft: 10, marginTop: 4 }}>
                    <Button
                      type="primary"
                      onClick={this.onAbrirFiltroClick}
                      className="botao-primary"
                      style={{ marginRight: 15 }}
                    >
                      Filtrar
                    </Button>
                  </Col>

                  <Col xs={2} style={{ width: 110, marginTop: 4 }}>
                    <CtasPagarRecPrintModal
                      filtros={filtros}
                      vlrReceber={this.state.vlrReceber}
                      vlrPagar={this.state.vlrPagar}
                      vlrTotal={this.state.vlrTotal}
                      vlrProvisao={this.state.vlrProvisao}
                      pessoa={this.state.filtros.buscaPessoa.label}
                    />
                  </Col>
                </Col>
              </Row>

              <Row>
                <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: 0 }}>

                  <Col xs={24} md={11} style={{ borderStyle: "solid", borderWidth: 2, color: Colors.primaryDark, marginRight: 30 }}>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVerde }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Entradas
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrRecebido)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVermelho }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Saídas
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrPago)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoAzul }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Saldo
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrSaldo)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                  </Col>

                  <Col xs={24} md={11} style={{ borderStyle: "solid", borderWidth: 2, color: Colors.primaryDark }}>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVerde }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            À Receber
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrReceber)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVermelho }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            À Pagar
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrPagar)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoAzul }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Provisão
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrProvisao)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Col>



            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <TituloLiquidarForm
              visivel={formLiqVisivel}
              onLiquidarClick={this.onLiquidarClick}
              onCancelarLiqClick={this.onCancelarLiqClick}
              registroParc={registroParc}
            />

            <RelContasPagRec
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
            >
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title="Data Venc"
                render={this.renderData}
                width={70}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pgto_data"
                dataIndex="pgto_data"
                title="Data Pagto"
                render={this.renderData}
                width={70}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tparc_parcela"
                dataIndex="tparc_parcela"
                title="Parcela"
                width={60}
                align="center"
                className="listaCadastro"
                render={this.renderParcela}
              />
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title="Controle"
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title="Número"
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pes_nome"
                dataIndex="pes_nome"
                title="Nome"
                width={100}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_abreviatura"
                dataIndex="pc_abreviatura"
                title="Conta"
                width={60}
                align="left"
                className="listaCadastro"
                render={this.renderCtaFin}
              />
              <Column
                key="tparc_valor"
                dataIndex="tparc_valor"
                title="Vlr Parcela"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_pago"
                dataIndex="pgto_vlr_pago"
                title="Vlr Pago"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_restante"
                dataIndex="pgto_vlr_restante"
                title="Vlr Restante"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title="Descrição"
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/CtasPagarRecPage.js